import { AutoTicket } from "../components/AutoTicket";

export default{
    init(){
        this.deleteingOrganisation();
        this.markAndRestoreDeletionOrganisation();
    },

    deleteingOrganisation(){
        $('.org_delete_btn').click(function(e) {
            e.preventDefault();
            const org_id = $(this).data('org_id');
            $('#confirm_delete_organisation_modal').modal('show');
            $('#confirm_delete_organisation_modal').find('.confirm_delete_organisation').data('org_id', org_id);
        })
        $('#confirm_delete_organisation_modal').on('click', '.confirm_delete_organisation', function(e) {
            e.preventDefault();
            console.log($(e.target).data('org_id'), $(this).data('org_id'));
            const org_id = $(e.target).data('org_id');
            if (org_id > 0) {
                $.ajax({
                    type: 'POST',
                    url: '/admin/delete-team',
                    data: {
                        'organisation_id': org_id,
                    },
                    success: (response) => {
                        if (response.result == true) {
                            window.location.href = '/admin/admin-edit-team';
                        }
                    },
                    error: (response) => {
                        $('#confirm_delete_organisation_modal').modal('hide');
                        $('#error-deleting-organisation-modal').modal('show');
                        const auto_ticket = new AutoTicket('#error-deleting-organisation-modal', '.create-ticket-button');
                        if (response.message) {
                            $('#error-deleting-organisation-modal').find('.result_message').text(response.message);
                            auto_ticket.createAutoTicket("Something went wrong when deleting an organization", JSON.stringify(response.responseJSON.description));
                        }else{
                            auto_ticket.createAutoTicket("Something went wrong when deleting an organization", JSON.stringify(response.responseJSON.description));
                        }
                    }
                });
            }
        })
    },

    markAndRestoreDeletionOrganisation(){
        $('.mark_as_deleted_organisation').click((e) => {
            const org_id = $(e.target).data('org_id');
            const url = '/admin/deletion-team';
            const data = {
                organisation_id: org_id,
                action: 'delete',
            };
            this.sendRequest(url, data, (response)=> { window.location.reload(true) });
        });
        $('.restore_deleting_organisation').click((e) => {
            const org_id = $(e.target).data('org_id');
            const url = '/admin/deletion-team';
            const data = {
                organisation_id: org_id,
                action: 'restore',
            };
            this.sendRequest(url, data, (response)=>{ window.location.reload(true)});
        });
    },

    /**
     *
     * @param {String} url
     * @param {Array} data
     * @param {String} type
     * @param {Function} successCallback
     * @param {Function} errorCallback
     */
    sendRequest(url, data, successCallback =()=>{}, errorCallback=()=>{}, type = 'POST'){
        $.ajax({
            type: type,
            url: url,
            data: data,
            success: (response)=>successCallback(response),
            error: (response)=>errorCallback(response),
        });
    }
}
